import React, { useState } from 'react';
import { useTutorial, TutorialData } from '../../contexts/TutorialContext';
import './TutorialStep.css';

const TutorialStep: React.FC = () => {
  const { state, completeStep, updateData, saveTutorialData } = useTutorial();
  const { currentStep, data } = state;
  const [newItem, setNewItem] = useState('');

  const handleNext = async () => {
    console.log('🔄 handleNext aufgerufen für Schritt:', currentStep);
    
    if (currentStep === 6) {
      // Letzter Schritt - Daten speichern
      try {
        await saveTutorialData();
        completeStep(currentStep);
        // Nach dem Speichern direkt zum Dashboard weiterleiten
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 100);
      } catch (error) {
        console.error('❌ Fehler beim Speichern der Tutorial-Daten:', error);
      }
    } else {
      console.log('🔄 Rufe completeStep auf mit step:', currentStep);
      completeStep(currentStep);
      console.log('✅ completeStep aufgerufen');
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      completeStep(currentStep - 2); // -2 weil completeStep den nächsten Schritt setzt
    }
  };

  const handleItemToggle = (category: keyof TutorialData, index: number) => {
    const newData = [...data[category]];
    newData[index] = { ...newData[index], isSelected: !newData[index].isSelected };
    updateData(category, newData);
  };

  const handleAddItem = (category: keyof TutorialData) => {
    if (newItem.trim()) {
      const newItemData = { name: newItem.trim(), isSelected: true };
      updateData(category, [...data[category], newItemData]);
      setNewItem('');
    }
  };

  const handleRemoveItem = (category: keyof TutorialData, index: number) => {
    const newData = data[category].filter((_, i) => i !== index);
    updateData(category, newData);
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="step-content welcome-step">
            <div className="step-icon">👋</div>
            <h3>Willkommen beim ASmonitor!</h3>
            <p>
              Der ASMmonitor ist dein digitaler Helfer für deine Atemschutz - Einsätze. Er bietet dir hilfreiche funktionen um deine Einsätze noch sicherer zu machen:
            </p>
            <ul>
              <li>✅ <strong>Trupperstellung</strong>: Erstelle Trupps schnell mit wenigen Klicks</li>
              <li>✅ <strong>Übersicht</strong>: Alle wichtigen Trupp-Infos auf einen Blick</li>
              <li>✅ <strong>Automationen</strong>: Automatisches Auditlog und mehr</li>
              <li>✅ <strong>Offline-Funktionalität</strong>: Funktioniert ohne Internet</li>
            </ul>
            <p>
              Lass uns gemeinsam die Grundlagen für deine Organisation einrichten...
            </p>
          </div>
        );

      case 2:
        return (
          <div>
            <h3>Einsatztypen definieren</h3>
            <p style={{ marginBottom: 20, color: '#666' }}>
              Wähle die Einsatztypen aus, die für deine Atemschutz-Einsätze relevant sind:
            </p>
            
            <div style={{ background: '#f8f9fa', borderRadius: 12, padding: 16, marginBottom: 20 }}>
              <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 16 }}>Verfügbare Einsatztypen:</div>
              <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 8, padding: 8, background: '#fff' }}>
                {data.operationsTypes.map((opsType) => {
                  const isSelected = opsType.isSelected;
                  return (
                    <div key={opsType.name} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center', 
                      padding: '8px 12px', 
                      marginBottom: 4,
                      background: isSelected ? '#e8f5e8' : '#f8f8f8',
                      borderRadius: 6,
                      border: isSelected ? '1px solid #4caf50' : '1px solid #ddd'
                    }}>
                      <span style={{ fontSize: 14, fontWeight: 500 }}>{opsType.name}</span>
                      <button 
                        onClick={() => handleItemToggle('operationsTypes', data.operationsTypes.findIndex(item => item.name === opsType.name))}
                        style={{ 
                          background: isSelected ? '#f44336' : '#4caf50', 
                          color: '#fff', 
                          border: 'none', 
                          borderRadius: 4, 
                          padding: '4px 8px', 
                          fontSize: 12, 
                          fontWeight: 700,
                          cursor: 'pointer'
                        }}
                        title={isSelected ? 'Entfernen' : 'Hinzufügen'}
                      >
                        {isSelected ? 'Entfernen' : 'Hinzufügen'}
                      </button>
                    </div>
                  );
                })}
              </div>
              <div style={{ marginTop: 12, fontSize: 14, color: '#666' }}>
                <strong>Ausgewählt:</strong> {data.operationsTypes.filter(item => item.isSelected).length} von {data.operationsTypes.length} Einsatztypen
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="step-content">
            <div className="step-icon">📍</div>
            <h3>Standorte für Atemschutz-Trupps</h3>
            <p>
              Nun solltest du für eine schnellere Abarbeitung deiner Status-Updates noch die Standorte definieren, 
              wo deine Atemschutz-Trupps sich aufhalten können während einem Einsatz.
            </p>
            
            <div className="items-list">
              {data.locations.map((item, index) => (
                <div key={index} className="item-row">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={item.isSelected}
                      onChange={() => handleItemToggle('locations', index)}
                    />
                    <span className="checkmark"></span>
                    {item.name}
                  </label>
                  {index > 1 && (
                    <button 
                      className="remove-btn"
                      onClick={() => handleRemoveItem('locations', index)}
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="add-item-section">
              <input
                type="text"
                placeholder="Neuen Standort hinzufügen..."
                value={newItem}
                onChange={(e) => setNewItem(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddItem('locations')}
              />
              <button onClick={() => handleAddItem('locations')}>Hinzufügen</button>
            </div>
          </div>
        );

      case 4:
        return (
          <div className="step-content">
            <div className="step-icon">📻</div>
            <h3>Funkkanäle einrichten</h3>
            <p>Welche Funkkanäle nutzt ihr für die Kommunikation?</p>
            
            <div className="items-list">
              {data.radioChannels.map((item, index) => (
                <div key={index} className="item-row">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={item.isSelected}
                      onChange={() => handleItemToggle('radioChannels', index)}
                    />
                    <span className="checkmark"></span>
                    {item.name}
                  </label>
                  {index > 1 && (
                    <button 
                      className="remove-btn"
                      onClick={() => handleRemoveItem('radioChannels', index)}
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="add-item-section">
              <input
                type="text"
                placeholder="Neuen Funkkanal hinzufügen..."
                value={newItem}
                onChange={(e) => setNewItem(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddItem('radioChannels')}
              />
              <button onClick={() => handleAddItem('radioChannels')}>Hinzufügen</button>
            </div>
          </div>
        );

      case 5:
        return (
          <div className="step-content">
            <div className="step-icon">📋</div>
            <h3>Standard-Aufgaben definieren</h3>
            <p>Welche Aufgaben gibt es bei euren Einsätzen?</p>
            
            <div className="items-list">
              {data.tasks.map((item, index) => (
                <div key={index} className="item-row">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={item.isSelected}
                      onChange={() => handleItemToggle('tasks', index)}
                    />
                    <span className="checkmark"></span>
                    {item.name}
                  </label>
                  {index > 3 && (
                    <button 
                      className="remove-btn"
                      onClick={() => handleRemoveItem('tasks', index)}
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="add-item-section">
              <input
                type="text"
                placeholder="Neue Aufgabe hinzufügen..."
                value={newItem}
                onChange={(e) => setNewItem(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddItem('tasks')}
              />
              <button onClick={() => handleAddItem('tasks')}>Hinzufügen</button>
            </div>
          </div>
        );

      case 6:
        return (
          <div className="step-content completion-step">
            <div className="step-icon">🎉</div>
            <h3>Tutorial abgeschlossen!</h3>
            <p>Perfekt! Deine Organisation ist bereit für ASMonitor.</p>
            
            <div className="summary">
              <h4>Du hast erfolgreich eingerichtet:</h4>
              <ul>
                <li>✅ <strong>Einsatztypen:</strong> {data.operationsTypes.filter(item => item.isSelected).map(item => item.name).join(', ')}</li>
                <li>✅ <strong>Standorte:</strong> {data.locations.filter(item => item.isSelected).map(item => item.name).join(', ')}</li>
                <li>✅ <strong>Funkkanäle:</strong> {data.radioChannels.filter(item => item.isSelected).map(item => item.name).join(', ')}</li>
                <li>✅ <strong>Aufgaben:</strong> {data.tasks.filter(item => item.isSelected).map(item => item.name).join(', ')}</li>
              </ul>
            </div>
            
            <p>Du kannst jetzt deinen ersten Einsatz starten!</p>
          </div>
        );

      default:
        return <div>Unbekannter Schritt</div>;
    }
  };

  return (
    <div className="tutorial-step">
      {renderStepContent()}
      
      <div className="step-navigation">
        {currentStep > 1 && (
          <button className="nav-btn back-btn" onClick={handleBack}>
            Zurück
          </button>
        )}
        
        <button 
          className="nav-btn next-btn" 
          onClick={handleNext}
          disabled={currentStep === 2 && data.operationsTypes.filter(item => item.isSelected).length === 0}
        >
          {currentStep === 6 ? 'Tutorial beenden' : 'Weiter'}
        </button>
      </div>
    </div>
  );
};

export default TutorialStep;
